// ViewSwitch: Segmented control for switching between Calendrier and Liste display modes
// Used in TeamView header to toggle the view mode
// CREATED: Part of the agenda list view for TeamView
// UPDATED: Use focus-visible instead of focus for ring (no green outline on mouse click)
// FIXED: Added aria-label to each button so screen readers have accessible names when text is hidden on mobile

import { CalendarDays, List } from 'lucide-react';

export type ViewMode = 'calendar' | 'list';

interface ViewSwitchProps {
  value: ViewMode;
  onChange: (value: ViewMode) => void;
}

export function ViewSwitch({ value, onChange }: ViewSwitchProps) {
  return (
    <div className="flex items-center bg-gray-100 rounded-lg p-0.5 flex-shrink-0" role="group" aria-label="Mode d'affichage">
      <button
        type="button"
        onClick={() => onChange('calendar')}
        aria-pressed={value === 'calendar'}
        aria-label="Calendrier"
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-1 ${
          value === 'calendar'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        <CalendarDays size={14} />
        <span className="hidden sm:inline">Calendrier</span>
      </button>
      <button
        type="button"
        onClick={() => onChange('list')}
        aria-pressed={value === 'list'}
        aria-label="Liste"
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-1 ${
          value === 'list'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        <List size={14} />
        <span className="hidden sm:inline">Liste</span>
      </button>
    </div>
  );
}
